/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  booking: ModelRegistry['booking'];
}

export interface BookingAcceptSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingSummaryAcceptComponent extends Component<BookingAcceptSignature> {
  @service router!: Services['router'];

  @cached
  get isMonthly(): boolean {
    return (this.router.currentRouteName ?? '').includes('monthly');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Summary::Accept': typeof UiBookingSummaryAcceptComponent;
  }
}
